import z from "zod";
import { OrderWorkflowActionIdScheme } from "../ids";
import { OrderStatus } from "../enums/OrderStatus";
import { OrderWorkflowActionType } from "../enums/OrderWorkflowActionType";

const OrderWorkflowActionBaseScheme = z.object({
  id: OrderWorkflowActionIdScheme,
  name: z.string(),
  enabled: z.boolean(),
});

const OrderWorkflowActionEmailScheme = OrderWorkflowActionBaseScheme.extend({
  type: z.literal(OrderWorkflowActionType.EMAIL),
  template: z.string(),
});

const OrderWorkflowActionPrintPrepTicketScheme =
  OrderWorkflowActionBaseScheme.extend({
    type: z.literal(OrderWorkflowActionType.PREP_TICKET),
  });

const OrderWorkflowActionUpdateEtaScheme = OrderWorkflowActionBaseScheme.extend(
  {
    type: z.literal(OrderWorkflowActionType.UPDATE_ETA),
  },
);

export const OrderWorkflowActionScheme = z.discriminatedUnion("type", [
  OrderWorkflowActionEmailScheme,
  OrderWorkflowActionPrintPrepTicketScheme,
  OrderWorkflowActionUpdateEtaScheme,
]);

export const OrderWorkflowStageScheme = z.object({
  status: z.enum(OrderStatus),
  enabled: z.boolean(),
  actions: z.array(OrderWorkflowActionScheme),
});

export type OrderWorkflowAction = z.infer<typeof OrderWorkflowActionScheme>;
export type OrderWorkflowStage = z.infer<typeof OrderWorkflowStageScheme>;
